var map = {
	"./azul.css": [
		"0a1c",
		"chunk-7451c246"
	],
	"./verde.css": [
		"cc58",
		"chunk-77216386"
	],
	"./vermelho.css": [
		"86af",
		"chunk-74afa6e6"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "bd05";
module.exports = webpackAsyncContext;